import { render } from "./App.vue?vue&type=template&id=241c724c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=241c724c&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__